// Dependencies
import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

// Hooks
import useLanguage from '../../hooks/useLanguage';

function fixedJobRequest() {
  const { locale } = useLanguage();
  const [t] = useTranslation(['routers', 'jobRequest'], { useSuspense: false });

  return (
    <>
      <div className="block-fixed-jobrequest">
        <Link to={`/${locale}/${t('JobRequests')}`}> {t('jobRequest:title')} </Link>
      </div>
    </>
  );
}

export default fixedJobRequest;
